// 管理员,交警,坐席,保险表头字段
export const commonAccidentList = {
  accidentId: '事故编号',
  reportPhone: '报警电话',
  accidentAddress: '事故地点',
  answerAgent: '接听坐席',
  caseDealType: '案件处理程序',
  liability: '定责',
  claim: '理赔',
  upload: '事故认定书',
  status: '事故状态'
};
// 医院表头字段
export const hospitalAccidentList = {
  code: '人伤直赔编号',
  accidentId: '关联事故编号',
  reportPhone: '报警电话',
  createTime: '申请时间',
  applicantStatus: '申请人身份',
  phone: '联系方式',
  name: '伤者姓名',
  gender: '伤者性别',
  identityNum: '伤者身份证号'
};
// 拖/修车表头字段
export const carAccidentList = {
  code: '车辆救援编号',
  accidentId: '关联事故编号',
  accidentAddress: '事故地点',
  accidentTime: '事故时间',
  driverName: '驾驶人姓名',
  driverPhone: '联系方式',
  carLicenseNum: '车牌号',
  maintenanceListUrl: '车辆清单',
  status: '事故状态',
  totalCost: '费用信息',
  claim: '理赔'
};